import {Evaluation} from "./evaluation";
import evaluation_template from './evaluation.twig'
import tabs_template from './tabs.twig'

export class AttendeeEvaluation extends Evaluation
{
    submit_evaluation(event){
        event.preventDefault();
        this.form = $(event.target).closest('form');

        if(this.checkRequired())
        {
            $.ajax({
                url	: "api/evaluation",
                type: "POST",
                data: this.form.serialize(),
                success	: (data) => {
                    if (data == "success")
                    {
                        $('#attendee_row_'+this.submit_callback_params).find('a.eval_link i').addClass('green').removeClass('red');
                        this.form.find(".missing_required_message").hide();
                        this.form.find(".evaluation_success_message").show();

                        if (this.submit_callback)
                        {
                            this.submit_callback(this.submit_callback_params);
                        }
                    }
                    else
                    {
                        this.form.find(".evaluation_success_message").hide();
                        this.form.find(".missing_required_message").show();
                        this.highlight_missing_required();
                    }
                }
            });
        }
        else
        {
            this.form.find(".evaluation_success_message").hide();
            this.form.find(".missing_required_message").show();
            this.highlight_missing_required();
        }
    }

    fetch_evaluation_html(target, meeting_id, attendee_id, anon_id, anon_type, callback, callback_params, mode = ""){
        $.ajax({
            url: "api/evaluation/data",
            type: "GET",
            data: {
                meeting_id	: meeting_id,
                attendee_id	: attendee_id,
                anon_id		: anon_id,
                anon_type	: anon_type,
                eval_mode   : mode
            }
        }).then((data) => {
            this.data = data;
            let html = $(twig({data: tabs_template}).render({
                eval_mode: mode,
                ...data
            }));
            let evalContainerDom = this.apply_evaluation_html(html, callback, callback_params);
            this.dom = evalContainerDom;

            Object.entries(data.evaluations).forEach(entry => {
                let evaluation = entry[1];
                let id = '#eval_tab_'+evaluation.topic_id+'_'+evaluation.speaker_id+'_'+evaluation.eval_type+'_'+evaluation.eval_id;

                let evalDom = $(twig({data: evaluation_template}).render({ form_index : entry[0], ...evaluation }));
                this.populate_answers(evalDom.find('form'));
                this.dom.find(id).append(evalDom);
            })

            this.processMode();
            $(target).append(this.dom);

            this.dom.find(".nav-link").first().trigger('click');

            this.dom.find('.ranked_choices').each((index, item) => {
                new Sortable(item);
            });
        });
    }
}
